const guideImages = {
    smms: 'https://imgbed.971229.xyz/file/1784903797191_clipboard.png',
    imgbb: 'https://imgbed.971229.xyz/file/1784903953798_clipboard.png'
};

export const webUploaderGuides = [
    {
        id: 'smms',
        titleKey: 'webUploaderGuide.guides.smms.title',
        summaryKey: 'webUploaderGuide.guides.smms.summary',
        documentationUrl: 'https://s.ee/docs/zh-CN/api/UploadFile/',
        deleteDocumentationUrl: 'https://s.ee/docs/zh-CN/api/DeleteFile/',
        image: guideImages.smms,
        fields: [
            { labelKey: 'sysUpload.channelNameLabel', valueKey: 'webUploaderGuide.guides.smms.fields.name' },
            { labelKey: 'sysUpload.webUploaderUrl', value: 'https://s.ee/api/v1/file/upload' },
            { labelKey: 'sysUpload.webUploaderParamName', value: 'file' },
            { labelKey: 'sysUpload.webUploaderJsonPath', value: 'data.url' },
            { labelKey: 'sysUpload.webUploaderHeaders', value: '{\n  "Authorization": "YOUR_S_EE_API_KEY"\n}' },
            { labelKey: 'sysUpload.webUploaderBody', valueKey: 'webUploaderGuide.guides.smms.fields.body' },
            { labelKey: 'sysUpload.webUploaderUrlPrefix', valueKey: 'webUploaderGuide.common.leaveEmpty' },
            { labelKey: 'sysUpload.webUploaderDeleteUrl', value: 'https://s.ee/api/v1/file/delete/{deleteKey}' },
            { labelKey: 'sysUpload.webUploaderDeleteMethod', value: 'GET' },
            { labelKey: 'sysUpload.webUploaderDeleteKeyPath', value: 'data.hash' },
            { labelKey: 'sysUpload.webUploaderDeleteHeaders', value: '{\n  "Authorization": "YOUR_S_EE_API_KEY"\n}' },
            { labelKey: 'sysUpload.webUploaderDeleteBody', valueKey: 'webUploaderGuide.common.leaveEmpty' }
        ],
        notes: [
            'webUploaderGuide.guides.smms.notes.apiKey',
            'webUploaderGuide.guides.smms.notes.deleteKey'
        ]
    },
    {
        id: 'imgbb',
        titleKey: 'webUploaderGuide.guides.imgbb.title',
        summaryKey: 'webUploaderGuide.guides.imgbb.summary',
        documentationUrl: 'https://api.imgbb.com/',
        image: guideImages.imgbb,
        fields: [
            { labelKey: 'sysUpload.channelNameLabel', valueKey: 'webUploaderGuide.guides.imgbb.fields.name' },
            { labelKey: 'sysUpload.webUploaderUrl', valueKey: 'webUploaderGuide.guides.imgbb.fields.uploadUrl' },
            { labelKey: 'sysUpload.webUploaderParamName', value: 'image' },
            { labelKey: 'sysUpload.webUploaderJsonPath', value: 'data.url' },
            { labelKey: 'sysUpload.webUploaderHeaders', valueKey: 'webUploaderGuide.common.leaveEmpty' },
            { labelKey: 'sysUpload.webUploaderBody', valueKey: 'webUploaderGuide.guides.imgbb.fields.body' },
            { labelKey: 'sysUpload.webUploaderUrlPrefix', valueKey: 'webUploaderGuide.common.leaveEmpty' },
            { labelKey: 'sysUpload.webUploaderDeleteUrl', value: '{deleteKey}' },
            { labelKey: 'sysUpload.webUploaderDeleteMethod', value: 'GET' },
            { labelKey: 'sysUpload.webUploaderDeleteKeyPath', value: 'data.delete_url' },
            { labelKey: 'sysUpload.webUploaderDeleteHeaders', valueKey: 'webUploaderGuide.common.leaveEmpty' },
            { labelKey: 'sysUpload.webUploaderDeleteBody', valueKey: 'webUploaderGuide.common.leaveEmpty' }
        ],
        notes: [
            'webUploaderGuide.guides.imgbb.notes.apiKey',
            'webUploaderGuide.guides.imgbb.notes.delete'
        ]
    }
];
